import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { UserResultProps } from "../../../../api/types";
import { AggregatedTable } from "./AggregatedTable";

export const EngagementStyle = StyleSheet.create({
	container: {
		position: "absolute",
		top: 120,
		paddingLeft: 49,
		paddingRight: 44,
		flexDirection: "column",
	},
	title: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "bold",
		fontSize: 32,
		marginBottom: 42,
	},
	tableListContainer: {
		flexDirection: "column",
	},
	tableContainer: {
		flexDirection: "column",
		marginBottom: 29,
	},
	tableTitle: {
		position: "relative",
		top: 3,
		left: 2,
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "semibold",
		fontSize: 20,
		marginBottom: 12,
	},
	table: {
		marginHorizontal: 10,
		width: 680,
	},
});

interface EngagementContentProps {
	data: UserResultProps;
}

export const EngagementContent: React.FC<EngagementContentProps> = ({
	data,
}): JSX.Element => (
	<View style={EngagementStyle.container}>
		<View style={EngagementStyle.tableListContainer}>
			<View wrap={false} style={EngagementStyle.tableContainer}>
				<Text style={EngagementStyle.tableTitle}>Topic Learning</Text>
				{data.topicGrades === null && (
					<Text
						style={{
							fontFamily: "Inter",
							fontStyle: "normal",
							fontWeight: "semibold",
							fontSize: 16,
						}}
					>
						THERE IS NO RECORDED GRADES OF TOPIC LEARNING
					</Text>
				)}
				{data.topicGrades && (
					<View style={EngagementStyle.table}>
						<AggregatedTable gradeList={data.topicGrades} />
					</View>
				)}
			</View>
			<View wrap={false} style={EngagementStyle.tableContainer}>
				<Text style={EngagementStyle.tableTitle}>General Capability</Text>
				{data.capabilityGrades === null && (
					<Text
						style={{
							fontFamily: "Inter",
							fontStyle: "normal",
							fontWeight: "semibold",
							fontSize: 16,
						}}
					>
						THERE IS NO RECORDED GRADES OF GENERAL CAPABILITY
					</Text>
				)}
				{data.capabilityGrades && (
					<View style={EngagementStyle.table}>
						<AggregatedTable gradeList={data.capabilityGrades} />
					</View>
				)}
			</View>
		</View>
	</View>
);
